import { NotificationsVue } from "fs-pb-vue2/vueModels/notifications/NotificationsVue";
import { Watch } from "vue-property-decorator";

export class NotificationsVueGB extends NotificationsVue {
    
  activeNotification: NotifyData | null = null;

  async showNotificationDetails(notify: NotifyData) {
    try {
      this.loading = true;
      this.activeNotification = notify;
      const res = await this.personService.fetchNotifyDetails(notify);

      if (this.activeNotification) {
        this.activeNotification.State = 2;
        this.activeNotification.Text = res.Text;
      }
      this.personStore.setNewNotifyCount();
    } catch (e) {
      this.activeNotification = null;
    }
    this.loading = false;
  }

  goBackToList() {
    this.activeNotification = null;
  }

  async deleteNotify(notify: NotifyData, e: any) {
    e.stopPropagation();
    this.personStore.setNotifyData(
      await this.personService.deleteNotify(notify.Id)
    );
    this.personStore.setNewNotifyCount();
    this.activeNotification = null;
  }

  get groupedNotifications(): Record<string, NotifyData[]> {
    return this.notifications.reduce((acc: Record<string, NotifyData[]>, item: NotifyData) => {
      const inputDate = new Date(item.Time);
      const date = this.getDisplayDate(inputDate);
      if (!acc[date]) {
        acc[date] = [];
      }
      acc[date].push(item);
      return acc;
    }, {});
  }

  getDisplayDate(inputDate: Date): string {
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);
    
    let rc: string;
  
    if (this.isSameDate(inputDate, today)) {
      rc = "Сегодня";
    } else if (this.isSameDate(inputDate, yesterday)) {
      rc = "Вчера";
    } else {
      const formattedDate = inputDate.toLocaleDateString("ru-RU", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
      const formattedDayOfWeek = inputDate.toLocaleDateString("ru-RU", {
        weekday: "short",
      });
      rc = `${formattedDate}, ${formattedDayOfWeek.toUpperCase()}`;
    }
  
    return rc;
  }
  
  isSameDate(date1: Date, date2: Date): boolean {
    return (
      date1.getDate() === date2.getDate() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getFullYear() === date2.getFullYear()
    );
  }
}